/*铭记历史*/
import {LEFTTJ,GDNEWS,ZHEXIESHI,urlpostfix,jsonpostfix} from '@/config/global.js'
import {getJSON,post} from '@/config/config.js'


/*地区*/
export function gethotareaJsondata(){
  return getJSON(`${jsonpostfix}allQyJSON/Hotarea.json`)
}
/*这些事json列表*/
export function getzxsJsondata(data){
  return getJSON(`${jsonpostfix}allWzJSON/${ZHEXIESHI}/${ZHEXIESHI}.json`,);
}
/*各地json列表*/
export function getgdjnJsondata(data){
  return getJSON(`${jsonpostfix}allWzJSON/${GDNEWS}/${GDNEWS}.json`,);
}
/*左侧栏json列表*/
export function getzctjJsondata(data){
  return getJSON(`${jsonpostfix}allWzJSON/${LEFTTJ}/${LEFTTJ}.json`,);
}

/*ajax列表*/
export function getgdjnAjaxdata(data){
  return post(`${urlpostfix}api/basic/getBasicNew`,data);
}












// WEBPACK FOOTER //
// ./src/api/rememberhistory.js